export default {
	bloglist: {
		en: [
			{
				title: 'How to Restore Deleted Messages in GB WhatsApp Pro',
				poster: require('@/assets/restore-deleted-messages-gb-whatsapp.jpg'),
				desc:
					'Deleted messages in GB WhatsApp Pro? Check your chat backups, follow the available restore options, and find out what you can recover without a backup.',
				url: '/restore-deleted-messages-gb-whatsapp/',
				name: 'en-restore-deleted-messages',
				date: '2026-10-22',
			},
			{
				title: 'How to Hide Online Status in GB WhatsApp Pro',
				poster: require('@/assets/hide-online-status-gbwhatsapp-pro.jpg'),
				desc:
					'Hide your online status in GB WhatsApp Pro to get more privacy while chatting. Find the relevant settings and understand what others can still see.',
				url: '/hide-online-status-gbwhatsapp-pro/',
				name: 'en-hide-online-status',
				date: '2026-10-22',
			},
			{
				title: 'How to Disable Blue Ticks in GB WhatsApp Pro (Hide Read Receipts)',
				poster: require('@/assets/disable-blue-ticks-in-gb-whatsapp.webp'),
				desc: 'Learn how to disable blue ticks in GB WhatsApp Pro and read messages without showing read receipts. Follow simple privacy settings steps.',
				url: '/disable-blue-ticks-in-gb-whatsapp/',
				name: 'en-disable-blue-ticks',
				date: '2026-08-07',
			},
			{
				title: 'How to Share Location on GB WhatsApp (Live Location Guide)',
				poster: require('@/assets/share-location-on-gb-whatsapp.webp'),
				desc: 'Learn how to share live location and current location on GB WhatsApp. Follow simple steps to send your location and manage privacy settings.',
				url: '/how-to-share-location-on-gb-whatsapp/',
				name: 'en-share-location',
				date: '2026-08-07',
			},
			{
				title: 'How to Lock Individual Chats in GB WhatsApp',
				poster: require('@/assets/lock-bg.png'),
				desc: 'Lock individual chats in GB WhatsApp with a PIN, password, pattern, or fingerprint to keep private conversations hidden from your main chat list.',
				url: '/how-to-lock-individual-chats-in-gb-whatsapp/',
				name: 'en-lock-individual-chats',
				date: '2026-08-31',
			},
		],
	},
}
